
<template>
  <div class="d-flex ml-1">
    <img
      :src="$ic.getImageUrl('activity', activity.type)"
      class="medium-thumbnail image-accent-dark mr-2"
    >
    <div v-if="activity && activity.name">
      <marquee v-if="$vuetify.breakpoint.xs && (activity.name.length > 25)" class="fg-accent-dark body-1" style="max-width: 140px">{{ activity.name }}</marquee>
      <span v-if="$vuetify.breakpoint.xs && (activity.name.length <= 25)" class="fg-accent-dark body-1" style="max-width: 140px">{{ activity.name }}</span>
      <marquee v-if="$vuetify.breakpoint.smAndUp && (activity.name.length > 50)" class="fg-accent-dark boday-2">{{ activity.name }}</marquee>
      <span v-if="$vuetify.breakpoint.smAndUp && (activity.name.length <= 50)" class="fg-accent-dark boday-2">{{ activity.name }}</span>
      <small class="fg-accent-dark d-flex">{{ $bc.toTitleCase(activity.type) }}</small>
    </div>
    <div v-if="activity.start_date" class="text-xs-right">
      <h3
        class="fg-accent-dark text-xs-right hidden-xs-only"
        v-html="$bc.fromNow(activity.start_date)"
      />
      <h5
        class="fg-accent-dark text-xs-right hidden-sm-and-up"
        v-html="$bc.fromNow(activity.start_date)"
      />
      <small class="fg-accent-dark" v-html="$bc.dateFormat(activity.start_date,'DD/MMM/YYYY')"/>
    </div>
    <div v-if="activity.distance" class="text-xs-right">
      <h3
        class="fg-accent-dark hidden-xs-only"
        v-html="$bc.distanceFormat(activity.distance,'major')"
      />
      <h5
        class="fg-accent-dark hidden-sm-and-up"
        v-html="$bc.distanceFormat(activity.distance,'major')"
      />
      <small class="fg-accent-dark" v-html="$bc.elevationFormat(activity.total_elevation_gain)"/>
    </div>
    <div v-if="activity.elapsed_time && activity.distance" class="text-xs-right mr-1">
      <h3
        class="fg-accent-dark text-xs-right hidden-xs-only"
        v-html="$bc.timeFormat(activity.elapsed_time)"
      />
      <h5
        class="fg-accent-dark text-xs-right hidden-sm-and-up"
        v-html="$bc.timeFormat(activity.elapsed_time)"
      />
      <small
        class="fg-accent-dark"
        v-html="$bc.speedFormat(activity.distance/activity.elapsed_time)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'activity-header-2',
  props: {
    activity: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data: () => ({
  }),
  methods: {
  },
};
</script>

<style lang="scss">
</style>
